import React from 'react'
import { Table } from 'antd'
import UMToolTip from '../../../components/UMToolTip'

const TableData = ({ tableData }) => {
  const columns = [
    {
      title: 'Iteration',
      dataIndex: 'iteration',
      key: 'iteration',
      align: 'center',
      render: (text, record, index) => <span>{index + 1}</span>
    },
    ...tableData.headers.map((header) => ({
      title: <UMToolTip>{header}</UMToolTip>,
      dataIndex: header,
      key: header,
      align: 'center',
      render: (text) => <UMToolTip>{text}</UMToolTip>
    }))
  ]

  const dataSource = tableData.data.map((row, index) => {
    const rowData = row.reduce((acc, cell, cellIndex) => {
      const header = tableData.headers[cellIndex]
      acc[header] = cell
      return acc
    }, {})

    return {
      key: index,
      ...rowData,
      iteration: index + 1
    }
  })

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      bordered
      className='custom-ant-table'
    />
  )
}

export default TableData
